import React from 'react';
import { ShieldCheck, Lock, CheckCircle } from 'lucide-react';
export function TrustBadges({
  size = 'md'
}: {
  size?: 'sm' | 'md';
}) {
  const iconSize = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';
  return <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-79">
      <div className={`flex items-center gap-2 ${textSize} font-medium text-gray-600`} data-id="element-80">
        <ShieldCheck className={iconSize} data-id="element-81" />
        <span data-id="element-82">Protección 100%</span>
      </div>
      <div className={`flex items-center gap-2 ${textSize} font-medium text-gray-600`} data-id="element-83">
        <Lock className={iconSize} data-id="element-84" />
        <span data-id="element-85">Pagos seguros</span>
      </div>
      <div className={`flex items-center gap-2 ${textSize} font-medium text-gray-600`} data-id="element-86">
        <CheckCircle className={iconSize} data-id="element-87" />
        <span data-id="element-88">Soporte activo</span>
      </div>
    </div>;
}